import { render, staticRenderFns } from "./OffTheStocks.vue?vue&type=template&id=10722d06&scoped=true&"
import script from "./OffTheStocks.vue?vue&type=script&lang=js&"
export * from "./OffTheStocks.vue?vue&type=script&lang=js&"
import style0 from "./OffTheStocks.vue?vue&type=style&index=0&id=10722d06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10722d06",
  null
  
)

export default component.exports